import React from 'react';
import Icon from '../../../components/AppIcon';

const DeliveryModeSelector = ({ selectedMode, onModeChange }) => {
  const deliveryModes = [
    {
      id: 'onsite',
      label: 'Onsite',
      icon: 'Building2',
      description: 'Engineers work at client location',
      multiplier: 1.0
    },
    {
      id: 'remote',
      label: 'Remote',
      icon: 'Home',
      description: 'Engineers work from office/home',
      multiplier: 0.85
    },
    {
      id: 'hybrid',
      label: 'Hybrid',
      icon: 'Shuffle',
      description: 'Mix of onsite and remote work',
      multiplier: 0.92
    }
  ];

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-foreground">
        Delivery Mode <span className="text-error">*</span>
      </label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {deliveryModes?.map((mode) => (
          <button
            key={mode?.id}
            onClick={() => onModeChange(mode?.id)}
            className={`flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all ${
              selectedMode === mode?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <Icon 
              name={mode?.icon} 
              size={32} 
              color={selectedMode === mode?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
            />
            <div className="text-center">
              <div className={`text-sm font-semibold ${
                selectedMode === mode?.id ? 'text-primary' : 'text-foreground'
              }`}>
                {mode?.label}
              </div>
              <div className="text-xs text-muted-foreground mt-1">
                {mode?.description}
              </div>
              <div className="text-xs text-muted-foreground mt-1">
                Cost Factor: {mode?.multiplier}x
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DeliveryModeSelector;